import NearMissCategorisation from "./components/NearMissCategorisation";

export default NearMissCategorisation;